import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/** The session you take on when you open a level beneath your own. */
const ROLE_FOR_SCOPE = {
  clinic: 'clinic_admin',
  region: 'region_admin',
  organization: 'org_admin',
};

export const OPEN_LABEL = {
  clinic: 'Open office',
  region: 'Open region',
  organization: 'Open organisation',
};

/**
 * Go and work inside an office, region or organisation beneath yours, as its
 * administrator.
 *
 * Anyone may open anything beneath them — an enterprise admin any of its organisations,
 * regions and offices; an organisation admin any of its regions and offices; a region
 * admin its offices. It is the ordinary portal handoff, so the server re-checks the
 * grant and records the switch like any other. Resolves only on failure: on success
 * the page is already navigating away.
 */
export async function openLevel(node) {
  const role = ROLE_FOR_SCOPE[node.scope];
  const body = node.scope === 'clinic'
    ? { role, clinic_id: node.id }
    : { role, node_id: node.id };
  const { data } = await axios.post(`${API_URL}/api/v1/auth/switch-portal`, body);
  window.location.assign(data.handoff_url);
}
